var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkgroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.70791 6.26799C9.66486 4.8487 8.91705 3.56027 7.71623 2.81754C7.83309 1.5132 6.8036 0.39209 5.50005 0.39209C4.19787 0.39209 3.16686 1.51169 3.28387 2.81754C2.08305 3.56027 1.33523 4.8487 1.29218 6.26799C0.0990923 6.82217 -0.353341 8.27044 0.299069 9.40044C0.946968 10.5227 2.43033 10.8647 3.50765 10.107C4.74854 10.7745 6.25128 10.7747 7.49242 10.107C8.56977 10.8647 10.053 10.5229 10.701 9.40044C11.3522 8.2727 10.9034 6.82341 9.70791 6.26799ZM5.50005 1.25137C6.25327 1.25137 6.86605 1.86415 6.86605 2.61735C6.86605 3.37056 6.25327 3.98335 5.50005 3.98335C4.74682 3.98335 4.13405 3.37058 4.13405 2.61735C4.13407 1.86417 4.74684 1.25137 5.50005 1.25137ZM1.04325 8.97083C0.665768 8.317 0.889353 7.48238 1.54322 7.10483C2.1974 6.72715 3.03191 6.95127 3.40922 7.60482C3.7858 8.25713 3.56153 9.0942 2.90923 9.47082C2.25694 9.84742 1.41983 9.62311 1.04325 8.97083ZM4.12191 9.45258C4.53424 8.77899 4.57527 7.90592 4.15338 7.17518C3.72954 6.44101 2.95449 6.04226 2.1662 6.06243C2.26161 5.10248 2.76347 4.23689 3.54357 3.67685C3.92079 4.37065 4.65634 4.84266 5.50007 4.84266C6.3438 4.84266 7.07935 4.37065 7.45657 3.67685C8.23667 4.23689 8.73853 5.10251 8.83394 6.06243C8.04767 6.0423 7.27168 6.43914 6.84676 7.17518C6.42487 7.90592 6.46588 8.77899 6.87823 9.45258C6.0049 9.84686 4.99582 9.84712 4.12191 9.45258ZM9.95687 8.97083C9.58027 9.62309 8.74318 9.84742 8.09089 9.47082C7.43859 9.0942 7.2143 8.25713 7.5909 7.60482C7.96832 6.95108 8.80294 6.72728 9.45689 7.10483C10.1107 7.48233 10.3344 8.31693 9.95687 8.97083Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkgroup);
export default __webpack_public_path__ + "static/media/workgroup.171690f66ccb8f1e03e75cb875ade93c.svg";
export { ForwardRef as ReactComponent };